import React, { useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import trayUpload from "@iconify/icons-mdi/tray-upload";
import { getData, uploadFile, postData } from "../../../webService/webservice.js";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import CategorySelect from "../../Challange/CategorySelect.jsx";
import SubCategorySelect from "../../Challange/SubCategorySelect.jsx";
import AddCategoryForm from "../Category/AddCategoryForm.jsx";
import AddSubCategoryForm from "../SubCategory/AddSubCategoryForm.jsx";
import TVFMLoader from "../Loader/loader.jsx";
import StockImagePicker from "../../../components/Common/ImagePicker/StockImagePicker.jsx";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { Typography } from "@mui/material";

const AddProductForm = ({ onSuccess, onCancel, initialStoreId }) => {
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const sessionToken = localStorage.getItem("Token");
    const userId = localStorage.getItem("userId");

    const [showLoader, setShowLoader] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [productImage, setProductImage] = useState(null);
    const [errors, setErrors] = useState({});
    const [categoryRefreshKey, setCategoryRefreshKey] = useState(0);
    const [subCategoryRefreshKey, setSubCategoryRefreshKey] = useState(0);
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [isAddSubCategory, setIsAddSubCategory] = useState(false);
    const [selectedStores, setSelectedStores] = useState([]);
    const [uploadMethod, setUploadMethod] = useState("Normal");
    const [selectedStockImage, setSelectedStockImage] = useState(null);
    const [showStockPicker, setShowStockPicker] = useState(false);

    const [formData, setFormData] = useState({
        title: '',
        productImageObject: '',
        categoryId: '',
        categoryName: '',
        subCategoryId: '',
        subCategoryName: '',
        storeId: [],
        upc: '',
        unitType: '',
        unitName: '',
        unitValue: '',
        ideal_for: '',
        purchasePrice: '',
        sellingPrice: '',
        gstPercentage: '',
        gstAmount: '',
        brandName: '',
        variantName: '',
    });

    useEffect(() => {
        const fetchStoreLabels = async () => {
            const ids = initialStoreId ? (Array.isArray(initialStoreId) ? initialStoreId : [initialStoreId]) : [];
            if (ids.length > 0) {
                const fetched = [];
                for (const id of ids) {
                    try {
                        const res = await getData(`stores/store/${id}`, {}, sessionToken);
                        if (res?.data) {
                            fetched.push({ value: res.data._id, label: res.data.storeName });
                        }
                    } catch (e) {
                        console.error("Error fetching store label", e);
                    }
                }
                setSelectedStores(fetched);
                setFormData(prev => ({ ...prev, storeId: fetched.map(m => m.value) }));
            }
        };
        fetchStoreLabels();
    }, [initialStoreId, sessionToken]);

    const unitOptions = {
        weight: ['Gram', 'Kilogram', 'Milligram'],
        volume: ['Litre', 'Millilitre'],
        unit: ['Piece', 'Packet', 'Bottle', 'Box'],
    };

    const calculateGSTAmount = (price, gst) => {
        const base = Number(price || 0);
        const gstPercent = Number(gst || 0);
        return ((base * gstPercent) / 100).toFixed(2);
    };

    const EMPTY_ARRAY = [];

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const loadCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            const sid = formData.storeId?.[0];
            const params = { page, limit: 10, search: inputValue };
            if (sid) params.storeId = sid;
            const res = await getData('categories/categories', params, sessionToken);
            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(cat => ({ value: cat._id, label: cat.categoryName }));
            return { options, hasMore: results.length === 10, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const loadSubCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            if (!formData.categoryId) return { options: [], hasMore: false };
            const sid = formData.storeId?.[0];
            const params = { page, limit: 10, search: inputValue, categoryId: formData.categoryId };
            if (sid) params.storeId = sid;
            const res = await getData('subcategories/subcategories', params, sessionToken);
            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(sub => ({ value: sub._id, label: sub.subCategoryName || sub.name }));
            return { options, hasMore: results.length === 10, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const validateFields = (data, method, img, stockImg) => {
        let newErrors = {};
        if (!data.storeId || data.storeId.length === 0) newErrors.storeId = "Store is required";
        if (!data.title?.trim()) newErrors.title = "Product Name is required";
        if (!data.unitType) newErrors.unitType = "UnitType is required";
        if (!data.unitName) newErrors.unitName = "UnitName is required";
        if (!data.categoryId) newErrors.categoryId = "Category is required";
        if (!data.subCategoryId) newErrors.subCategoryId = "Sub Category is required";
        if (!data.ideal_for) newErrors.ideal_for = "Ideal For is required";
        if (data.gstPercentage === "" || data.gstPercentage === undefined) newErrors.gstPercentage = "GST Percentage is required";

        if (method === "Normal" && img) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
            const allowedExtensions = ["jpg", "jpeg", "png"];
            const fileExtension = img.name.split('.').pop().toLowerCase();
            const isValidType = allowedTypes.includes(img.type) || allowedExtensions.includes(fileExtension);
            if (!isValidType) {
                newErrors.productImage = "Only JPEG, JPG, and PNG images are allowed.";
            } else if (img.size > 1024 * 1024) {
                newErrors.productImage = "Image size exceeds 1MB. Please select an image smaller than 1MB.";
            }
        }
        return newErrors;
    };

    const handleAddProduct = async (e) => {
        e.preventDefault();
        const validationErrors = validateFields(formData, uploadMethod, productImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setShowLoader(true);
        try {
            let productImageObject = null;
            const isStockUpload = uploadMethod === "Stock";

            if (!isStockUpload) {
                if (productImage) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, productImage);
                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        productImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                }
            } else {
                productImageObject = selectedStockImage;
            }



            const productData = {
                storeId: formData.storeId,
                title: formData.title,

                categoryId: formData.categoryId,
                subCategoryId: formData.subCategoryId,
                upc: formData.upc,
                unitType: formData.unitType,
                unitName: formData.unitName,
                ideal_for: formData.ideal_for,
                sellingPrice: formData.sellingPrice,
                gstPercentage: formData.gstPercentage,
                gstAmount: formData.gstAmount,
                brandName: formData.brandName,
                variantName: formData.variantName,
                productImageObject,
                imageSource: isStockUpload ? "Stock" : "Upload"
            };

            const response = await postData("products/", productData, sessionToken);
            toast.success(response.message || "Product added successfully");
            if (onSuccess) onSuccess(response.data);
        } catch (error) {
            toast.error("Add Product Failed");
        } finally {
            setShowLoader(false);
        }
    };
    const handleRemoveImage = () => {
        setProductImage(null);
        setSelectedStockImage(null);
        setPreviewUrl(null);
        setErrors(prev => ({ ...prev, productImage: null }));
    };

    const handleStockSelect = (imageObject) => {
        if (!imageObject) return;
        setSelectedStockImage(imageObject);
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        const uri = imageObject.uri || imageObject.fileObject?.uri || "";
        if (uri) {
            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
        }
        setShowStockPicker(false);
        setErrors(prev => ({ ...prev, productImage: null }));
    };

    return (
        <div className="add-Product-form" style={{ background: 'white', padding: '20px', borderRadius: '8px' }}>
            {showLoader && (
                <div className="scissor-overlay">
                    <div className="scissor-loader"><TVFMLoader /></div>
                </div>
            )}
            <Typography variant="h6" gutterBottom>Add Product</Typography>
            <form className="Product-form" onSubmit={handleAddProduct}>
                <div className="Product-form-row">
                    <div className="Product-form-group">
                        <label className="input-label">Product Name</label>
                        <input
                            type="text"
                            placeholder="Enter Product name"
                            className="Product-input"
                            value={formData.title}
                            onChange={e => setFormData(prev => ({ ...prev, title: e.target.value }))}
                        />
                        {errors.title && <p className="field-error">{errors.title}</p>}
                    </div>
                    <div className="Product-form-group">
                        <label className="input-label">Branch Name</label>
                        <StoreMultiSelect
                            value={selectedStores}
                            onChange={(val) => {
                                setSelectedStores(val);
                                setFormData(prev => ({
                                    ...prev,
                                    storeId: val.map(v => v.value),
                                    categoryId: "",
                                    categoryName: "",
                                    subCategoryId: "",
                                    subCategoryName: ""
                                }));
                            }}
                            loadStores={loadStores}
                            loggedInRole={role}
                            assignedStoreIds={adminStoreIds}
                        />
                        {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                    </div>
                </div>

                <div className="Product-form-row">
                    <div className="Product-form-group">
                        <label className="input-label">UPC Number</label>
                        <input
                            type="text"
                            className="Product-input"
                            maxLength={12}
                            value={formData.upc}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,12}$/.test(value)) {
                                    setFormData((prev) => ({ ...prev, upc: value }));
                                }
                            }}
                        />
                        {errors.upc && <p className="field-error">{errors.upc}</p>}
                    </div>
                    <div className="Product-form-group">
                        <label className="input-label">Unit Type</label>
                        <select
                            className="Product-input"
                            value={formData.unitType}
                            onChange={(e) => setFormData((prev) => ({ ...prev, unitType: e.target.value, unitName: '' }))}
                        >
                            <option value=''>Select Unit Type</option>
                            <option value='weight'>Weight</option>
                            <option value='volume'>Volume</option>
                            <option value='unit'>Unit</option>
                        </select>
                        {errors.unitType && <p className="field-error">{errors.unitType}</p>}
                    </div>
                    <div className="Product-form-group">
                        <label className="input-label">Unit Name</label>
                        <select
                            className="Product-input"
                            disabled={!formData.unitType}
                            value={formData.unitName}
                            onChange={(e) => setFormData((prev) => ({ ...prev, unitName: e.target.value }))}
                        >
                            <option value="">Select UnitName</option>
                            {(unitOptions[formData.unitType] || []).map((unit) => (
                                <option key={unit} value={unit}>{unit}</option>
                            ))}
                        </select>
                        {errors.unitName && <p className="field-error">{errors.unitName}</p>}
                    </div>
                </div>

                <div className="Product-form-row">
                    <div className="Product-form-group">
                        <label className="input-label">Category</label>
                        <CategorySelect
                            key={`${formData.storeId}-${categoryRefreshKey}`}
                            value={formData.categoryId ? { value: formData.categoryId, label: formData.categoryName || "Selected Category" } : null}
                            onChange={(val) => {
                                setFormData(prev => ({
                                    ...prev,
                                    categoryId: val?.value || "",
                                    categoryName: val?.label || "",
                                    subCategoryId: "",
                                    subCategoryName: ""
                                }));
                            }}
                            loadCategories={loadCategories}
                            onAddCategory={() => setIsAddCategory(true)}
                        />
                        {errors.categoryId && <p className="field-error">{errors.categoryId}</p>}
                    </div>
                    <div className="Product-form-group">
                        <label className="input-label">Sub Category</label>
                        <SubCategorySelect
                            key={`${formData.storeId}-${formData.categoryId}-${subCategoryRefreshKey}`}
                            value={formData.subCategoryId ? { value: formData.subCategoryId, label: formData.subCategoryName || "Selected SubCategory" } : null}
                            onChange={(val) => {
                                setFormData(prev => ({
                                    ...prev,
                                    subCategoryId: val?.value || "",
                                    subCategoryName: val?.label || ""
                                }));
                            }}
                            loadSubCategories={loadSubCategories}
                            onAddSubCategory={() => setIsAddSubCategory(true)}
                        />
                        {errors.subCategoryId && <p className="field-error">{errors.subCategoryId}</p>}
                    </div>
                    <div className="Product-form-group">
                        <label htmlFor="ideal_for" className="input-label">
                            Ideal For
                        </label>
                        <select
                            id="ideal_for"
                            className="Product-input"
                            required
                            disabled={!formData.subCategoryId}
                            value={formData.ideal_for}
                            onChange={(e) => {
                                setFormData((prev) => ({ ...prev, ideal_for: e.target.value }))
                            }}
                        >
                            <option value='' >Select Ideal For</option>
                            <option value='men'>Men</option>
                            <option value='women'>Women</option>
                            <option value='unisex'>Unisex</option>
                        </select>
                        {errors.ideal_for && <p className="field-error">{errors.ideal_for}</p>}
                    </div>
                </div>

                <div className="Product-form-row">
                    <div className="Product-form-group">
                        <label className="input-label">GST (%)</label>
                        <select
                            className="Product-input"
                            value={formData.gstPercentage}
                            onChange={(e) => {
                                const gstPercentage = Number(e.target.value);
                                setFormData(prev => ({
                                    ...prev,
                                    gstPercentage
                                }));
                            }}
                        >
                            <option value="">Select GST</option>
                            <option value="0">0%</option>
                            <option value="5">5%</option>
                            <option value="12">12%</option>
                            <option value="18">18%</option>
                        </select>
                        {errors.gstPercentage && <p className="field-error">{errors.gstPercentage}</p>}
                    </div>
                </div>

                <div className="Product-form-row">
                    <div className="Product-form-group" style={{ gridColumn: 'span 2' }}>
                        <label htmlFor="AddProductImage" className="input-label">Product Image (Max 1MB, JPEG/JPG/PNG only)</label>
                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                <input
                                    type="radio"
                                    name="addUploadMethod"
                                    checked={uploadMethod === "Normal"}
                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                    onChange={() => {
                                        setUploadMethod("Normal");
                                        setPreviewUrl(productImage ? URL.createObjectURL(productImage) : null);
                                    }}
                                />
                                Normal Upload
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                <input
                                    type="radio"
                                    name="addUploadMethod"
                                    checked={uploadMethod === "Stock"}
                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                    onChange={() => {
                                        setUploadMethod("Stock");
                                        if (selectedStockImage) {
                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                        } else {
                                            setPreviewUrl(null);
                                        }
                                    }}
                                />
                                Stock Image
                            </label>
                        </div>

                        {uploadMethod === "Normal" ? (
                            <div className="file-input-wrapper">
                                <input
                                    type="file"
                                    accept=".jpeg,.jpg,.png"
                                    id="AddProductImage"
                                    className="Product-input"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                            const allowedExtensions = ["jpg", "jpeg", "png"];
                                            const fileExtension = file.name.split('.').pop().toLowerCase();
                                            const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                            if (!isValidType) {
                                                setErrors(prev => ({ ...prev, productImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                setProductImage(null);
                                                setPreviewUrl(null);
                                                if (e.target) e.target.value = "";
                                            } else if (file.size > 1024 * 1024) {
                                                setErrors(prev => ({ ...prev, productImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                setProductImage(null);
                                                setPreviewUrl(null);
                                                if (e.target) e.target.value = "";
                                            } else {
                                                setProductImage(file);
                                                setPreviewUrl(URL.createObjectURL(file));
                                                setErrors(prev => ({ ...prev, productImage: null }));
                                            }
                                        }
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="stock-picker-trigger">
                                <button
                                    type="button"
                                    className="select-stock-btn"
                                    onClick={() => setShowStockPicker(true)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        background: '#fff',
                                        border: '1px solid #ccc',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'left',
                                        justifyContent: 'flex-start',
                                        gap: '10px',
                                        fontSize: '14px',
                                        color: selectedStockImage ? '#333' : '#888'
                                    }}
                                >
                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                </button>
                            </div>
                        )}
                        {errors.productImage && <p className="field-error">{errors.productImage}</p>}

                        {previewUrl && (
                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                <div style={{ position: 'relative' }}>
                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-8px',
                                            right: '-8px',
                                            background: '#ef4444',
                                            color: 'white',
                                            borderRadius: '50%',
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                            zIndex: 5
                                        }}
                                        onClick={handleRemoveImage}
                                        title="Remove image"
                                    >
                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                    </div>
                                </div>
                                {uploadMethod === "Stock" && selectedStockImage && (
                                    <div style={{ paddingTop: '4px' }}>
                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className="Product-buttons">
                    <button className="add-Product-button" type="submit">Add Product</button>
                    <button className="cancel-Product-button" type="button" onClick={onCancel}>Cancel</button>
                </div>
            </form>

            {isAddCategory && (
                <div className="popup-overlay">
                    <div className="popup-wrapper">
                        <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddCategory(false)} />
                        <AddCategoryForm
                            onCancel={() => setIsAddCategory(false)}
                            initialStoreId={formData.storeId?.[0]}
                        />
                    </div>
                </div>
            )}

            {isAddSubCategory && (
                <div className="popup-overlay">
                    <div className="popup-wrapper">
                        <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddSubCategory(false)} />
                        <AddSubCategoryForm
                            onSuccess={() => { setIsAddSubCategory(false); setSubCategoryRefreshKey(prev => prev + 1); }}
                            onCancel={() => setIsAddSubCategory(false)}
                            initialStoreId={formData.storeId?.[0]}
                            categoryId={formData.categoryId}
                            hideAddCategory={true}
                        />
                    </div>
                </div>
            )}
            {showStockPicker && (
                <StockImagePicker
                    onSelect={handleStockSelect}
                    onCancel={() => setShowStockPicker(false)}
                />
            )}
        </div>
    );
};

export default AddProductForm;

